<template lang="pug">
    div
        p.m-t-md.m-b-md
            | Add new modifier sets and modifiers or update existing ones. 
            a.text-info(:href="templateUrl") Download our template
            |  file and add your modifier details.
        dropzone(
            ref="dropzone"
            id="import-modifier-dropzone" 
            paramName="file"
            :url="url" 
            acceptedFileTypes=".csv,.xls,.xlsx"
            :maxNumberOfFiles="1"
            @vdropzone-success="uploadSuccessCallback",
            @vdropzone-error="errorHandler",
            :autoProcessQueue="false"
        )
</template>
<script>
export default {
    computed: {
        templateUrl() {
            return Laroute.route(
                'franchise.inventory.modifier.exportTemplate',
                {
                    type: 'CSV',
                },
            );
        },

        url() {
            return Laroute.route('franchise.inventory.modifier.import');
        },

        loader() {
            return 'upload modifier file';
        },
    },

    methods: {
        uploadSuccessCallback(file, response) {
            this.$emit('success', response);
            this.removeFile();
        },

        submit() {
            if (this.onLoading(this.loader)) {
                return;
            }

            if (this.hasRejectedFile()) {
                this.showToastrError('File not valid');
                return;
            }

            if (this.hasFileToUpload()) {
                this.startLoading(this.loader);
                this.uploadFile();
            } else {
                this.showToastrError('No file selected');
            }
        },

        hasRejectedFile() {
            return this.$refs.dropzone.getRejectedFiles().length > 0;
        },

        hasFileToUpload() {
            let files = this.$refs.dropzone.getAcceptedFiles();
            return !_.isEmpty(files) && files[0].name != '';
        },

        uploadFile() {
            this.$refs.dropzone.processQueue();
        },

        errorHandler(file, error, xhr) {
            this.endLoading(this.loader);
            this.removeFile();
            this.showApiError(error, 'File Upload Failed');
        },

        cancel() {
            this.$emit('cancel');
        },

        removeFile() {
            this.$refs.dropzone.removeAllFiles();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/modifier/import-modifier-form.vue